import React from 'react';

import { Switch, Route } from 'react-router-dom';

import * as Page from '~/pages';

import AppRoute from './AppRoute';
import AuthRoute from './AuthRoute';

// import Route from './route';

// eslint-disable-next-line no-shadow
enum UserRoles {
  student = 'student',
  professional = 'professional',
  gym = 'gym',
}

const Routes: React.FC = () => {
  return (
    <Switch>
      <AuthRoute path="/" exact component={Page.Home} />
      <AuthRoute path="/terms-of-use" component={Page.TermsOfUse} />
      <AuthRoute path="/policy-privacy" component={Page.PolicyPrivacy} />

      <AuthRoute
        path="/sign-up/terms-of-use"
        exact
        component={Page.SignUpTermsOfUse}
      />
      <AuthRoute
        path="/sign-up/policy-privacy"
        exact
        component={Page.SignUpPolicyPrivacy}
      />

      <AuthRoute path="/sign-plan" exact component={Page.SignPlan} />

      {/* <AuthRoute
        path="/sign-up/complete"
        exact
        component={Page.SignUpComplete}
      /> */}

      {/*   STUDENT  */}
      {/* <AuthRoute
        path="/student/sign-in"
        exact
        component={Page.Student.SignIn}
      /> */}

      {/* <AppRoute
        path="/student/students"
        exact
        component={Page.Student.Students}
        requiredRoles={[String(UserRoles.student)]}
      /> */}

      {/*   PROFESSIONAL  */}
      <AuthRoute
        path="/professional/sign-in"
        exact
        component={Page.Professional.SignIn}
      />

      <AuthRoute
        path="/professional/sign-up"
        exact
        component={Page.Professional.SignUp}
      />

      <AuthRoute
        path="/professional/sign-up/complete"
        exact
        component={Page.Professional.SignUpComplete}
      />

      <AuthRoute
        path="/professional/sign-up/complete/payment-card"
        exact
        component={Page.Professional.RegisterPaymentCard}
      />

      <AuthRoute
        path="/professional/download-app"
        exact
        component={Page.Professional.RedirectToMobile}
      />

      <AppRoute
        path="/professional/students"
        exact
        component={Page.Professional.Students}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/register"
        exact
        component={Page.Professional.StudentRegister}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId"
        exact
        component={Page.Professional.StudentProfile}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/edit"
        exact
        component={Page.Professional.StudentEdit}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billings/register"
        exact
        component={Page.Professional.BillingRegister}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billings/:billingId"
        exact
        component={Page.Professional.Billing}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billings/:billingId/edit"
        exact
        component={Page.Professional.BillingEdit}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/datasheet/register"
        exact
        component={Page.Professional.DataSheetRegister}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/datasheet/:dataSheetId"
        exact
        component={Page.Professional.DataSheet}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/datasheet/:dataSheetId/edit"
        exact
        component={Page.Professional.DataSheetEdit}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/training-management"
        exact
        component={Page.Professional.TrainingManagement}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/training-division"
        exact
        component={Page.Professional.TrainingDivision}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/basic/training-division"
        exact
        component={Page.Professional.BasicTrainingProtocol}
        requiredRoles={[String(UserRoles.professional)]}
      />
      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/premium/training-division"
        exact
        component={Page.Professional.PremiumTrainingProtocol}
        requiredRoles={[String(UserRoles.professional)]}
      />
      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/masterclass/training-division"
        exact
        component={Page.Professional.MasterClassTrainingProtocol}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/students/:userId/billing/:billingId/training-programs/:programId/turbo-training"
        exact
        component={Page.Professional.TurboTraining}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/manager"
        exact
        component={Page.Professional.Manager}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/manager-report"
        exact
        component={Page.Professional.ManagerReport}
        requiredRoles={[String(UserRoles.professional)]}
      />
      <AppRoute
        path="/professional/manager-report/commercial"
        exact
        component={Page.Professional.CommercialReport}
        requiredRoles={[String(UserRoles.professional)]}
      />
      <AppRoute
        path="/professional/manager-report/technical-management"
        exact
        component={Page.Professional.TechnicalManagementReport}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/settings"
        exact
        component={Page.Professional.Settings}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab"
        exact
        component={Page.Professional.Lab}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/power-creator"
        exact
        component={Page.Professional.PowerCreator}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/power-creator/:id/edit"
        exact
        component={Page.Professional.PowerCreatorEdit}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/met-library"
        exact
        component={Page.Professional.MetLibrary}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/met-library/archive"
        exact
        component={Page.Professional.MetLibraryArchive}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/met-library/import-methods"
        exact
        component={Page.Professional.MetLibraryImportMethods}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/met-library/:id/details"
        exact
        component={Page.Professional.MetLibraryDetails}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/ex-editor"
        exact
        component={Page.Professional.ExEditor}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/ex-editor/:id"
        exact
        component={Page.Professional.ExEditorEdit}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/ex-library"
        exact
        component={Page.Professional.ExLibrary}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/training-store/profile-code"
        exact
        component={Page.Professional.TrainingStoreProfileCode}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/training-store/technical-data"
        exact
        component={Page.Professional.TrainingStoreTechnicalData}
        requiredRoles={[String(UserRoles.professional)]}
      />

      <AppRoute
        path="/professional/lab/symbology"
        exact
        component={Page.Professional.Symbology}
        requiredRoles={[String(UserRoles.professional)]}
      />

      {/* GYM */}
      {/* <AuthRoute path="/gym/sign-in" exact component={Page.Gym.SignIn} /> */}

      {/* <AuthRoute path="/gym/sign-up" exact component={Page.Gym.SignUp} /> */}

      <Route
        path="/professional/forget-password"
        component={Page.PasswordRecover}
      />
      <Route path="/unauthorized" component={Page.Unauthorized} />
      <Route component={Page.NotFound} />
    </Switch>
  );
};

export default Routes;
